import { createElement } from "react";
import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { List, Collapse, Typography } from "@mui/material";
import { Components_CollapseChevronButton_5E9F1DB5 } from "./CollapseChevronButton.js";
import { singleton, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";

export function Components_TreeContainer_4089C375(components_TreeContainer_4089C375InputProps) {
    let elems_3, elems, elements_1;
    const listItems = components_TreeContainer_4089C375InputProps.listItems;
    const titleIcon = components_TreeContainer_4089C375InputProps.titleIcon;
    const title = components_TreeContainer_4089C375InputProps.title;
    const key = components_TreeContainer_4089C375InputProps.$key;
    let patternInput;
    const initial = !(listItems.length === 0);
    patternInput = reactApi.useState(initial);
    const isOpen = patternInput[0];
    return createElement("div", createObj(singleton((elems_3 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        columnGap: 10 + "px",
    }], (elems = [titleIcon, MuiHelpers_createElement(Typography, [["variant", "h6"], ["children", title]]), createElement(Components_CollapseChevronButton_5E9F1DB5, {
        isOpen: isOpen,
        onClick: () => {
            patternInput[1](!isOpen);
        },
        disabled: listItems.length === 0,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), MuiHelpers_createElement(Collapse, [["mountOnEnter", true], ["unmountOnExit", true], ["in", isOpen], (elements_1 = [MuiHelpers_createElement(List, [["children", reactApi.Children.toArray(Array.from(listItems))]])], ["children", reactApi.Children.toArray(Array.from(elements_1))])])], ["children", reactApi.Children.toArray(Array.from(elems_3))]))));
}

